import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
        <h1 className="text-3xl font-bold text-green-700 mb-2 text-center">⛳ Golf Society Manager</h1>
        <h2 className="text-xl font-semibold text-gray-600 mb-6 text-center">Reset Password</h2>
        {sent ? (
          <div className="bg-green-100 text-green-700 px-4 py-3 rounded text-sm text-center">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500" />
            </div>
            <button onClick={handleSubmit} disabled={loading}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg text-sm">
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        )}
        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/login" className="text-green-600 hover:underline">Back to Sign In</Link>
        </p>
        <p className="text-center text-xs text-gray-400 mt-6">© 2026 Michael Sellman. Golf Society Manager.</p>
      </div>
    </div>
  );
}
